<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { edition } from "@edition";
import { LEGAL_LINKS } from "@/legal/links";

const { t } = useI18n({ useScope: "global" });
const brand = computed(() => t(edition.ui.brandKey));

const legalLinks = [
  { label: "Terms", href: LEGAL_LINKS.terms },
  { label: "Privacy", href: LEGAL_LINKS.privacy },
  { label: "Refunds", href: LEGAL_LINKS.refund },
  { label: "Cookies", href: LEGAL_LINKS.cookies },
  { label: "Acceptable Use", href: LEGAL_LINKS.acceptableUse },
  { label: "Community Guidelines", href: LEGAL_LINKS.community },
] as const;
</script>

<template>
  <footer class="border-t border-line bg-panel/60 text-muted">
    <div
      class="mx-auto grid w-full max-w-7xl gap-7 px-5 py-8 sm:px-8 lg:grid-cols-[minmax(0,1.4fr)_minmax(260px,1fr)] lg:gap-12 lg:py-10"
    >
      <section aria-labelledby="footer-company">
        <p class="text-xs font-semibold uppercase tracking-[0.16em] text-brand">
          {{ brand }}
        </p>
        <h2 id="footer-company" class="mt-2 text-sm font-semibold text-white">
          NebulaMatrix Limited
          <span class="font-normal text-muted">(星算矩陣有限公司)</span>
        </h2>
        <div class="mt-3 space-y-1 text-xs leading-relaxed sm:text-sm">
          <p>Company No. 80686894</p>
          <p>
            Room 605, 6/F., Easey Commercial Building, 253-261 Hennessy Road,
            Wan Chai, Hong Kong
          </p>
          <p>
            <a
              href="mailto:notbad202488@gmail.com"
              class="transition hover:text-brand hover:underline"
            >
              notbad202488@gmail.com
            </a>
          </p>
        </div>
      </section>

      <nav aria-label="Legal policies">
        <router-link
          v-if="edition.region === 'global'"
          to="/download"
          class="mb-4 inline-flex text-sm font-medium text-brand hover:underline"
        >
          {{ t('download.nav') }} &rarr;
        </router-link>
        <h2 class="text-sm font-semibold text-white">Legal &amp; Policies</h2>
        <div class="mt-3 flex flex-wrap gap-x-5 gap-y-2 text-xs sm:text-sm">
          <a
            v-for="link in legalLinks"
            :key="link.href"
            :href="link.href"
            target="_blank"
            rel="noopener noreferrer"
            class="transition hover:text-brand hover:underline"
          >
            {{ link.label }}
          </a>
        </div>
        <a
          href="/legal"
          class="mt-4 inline-flex text-xs font-medium text-brand hover:underline sm:text-sm"
        >
          View Legal Center &rarr;
        </a>
      </nav>
    </div>

    <div class="border-t border-line/70 px-5 py-4 text-center text-[11px] sm:text-xs">
      &copy; 2026 NebulaMatrix Limited. All rights reserved.
      <span class="mx-1" aria-hidden="true">&middot;</span>
      <a href="https://hyfun.games" class="hover:text-brand hover:underline">
        hyfun.games
      </a>
    </div>
  </footer>
</template>
